import inlineSVG from '@gearset/web-core/scripts/inlineSvg.js';
import calendly from 'Scripts/calendly.js';
import whenVisible from 'Utils/whenVisible.js';
import analytics from 'Scripts/analytics.js';

window.removeSeparatorAtEndOfLine = () => {
	let lastElement = false;
	const els = document.querySelectorAll('#hero ul li');

	if (els.length > 0) {
		for (const element of els) {
			if (lastElement && lastElement.offsetTop !== element.offsetTop) {
				lastElement.classList.remove('has-bullet');
			} else if (lastElement) {
				lastElement.classList.add('has-bullet');
			}

			lastElement = element;
		}

		els[els.length - 1].classList.remove('has-bullet');
	}
};

document.addEventListener('DOMContentLoaded', () => {
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, () => {
		document.documentElement.classList.toggle('is-loaded');
	});

	calendly.setUpCalendly();
	window.removeSeparatorAtEndOfLine();
	analytics.trackTaggedAnchors();

	/* Coffee landing page */

	if (document.querySelector('#coffee-times')) {
		document.querySelector('#coffee-times-toggle')?.addEventListener('click', event => {
			event.preventDefault();
			document.querySelector('#coffee-times')?.classList.add('is-active');
			return false;
		});
		document.querySelector('#coffee-times')?.addEventListener('click', () => {
			document.querySelector('#coffee-times')?.classList.remove('is-active');
		});
	}

	// Handle mobile navigation
	// Check for click events on the navbar burger icon

	const navbarBurger = document.querySelector('.navbar-burger');
	const navbarMenu = document.querySelector('.navbar-menu');

	navbarBurger?.addEventListener('click', () => {
		// Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
		navbarBurger?.classList.toggle('is-active');
		navbarMenu?.classList.toggle('is-active');
	});

	// Apply class when element is visible
	whenVisible();
});
window.addEventListener('resize', window.removeSeparatorAtEndOfLine);
